import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索火影西瓜玩法
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            五大创意分类，每一种都让你的夏日吃瓜体验充满忍道精神
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block bg-background-100 hover:bg-background-200/70 rounded-lg p-6 transition-all cursor-pointer border border-background-200/70 hover:border-primary-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.articleCount} 篇文章 &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}